import {types} from "mobx-state-tree";

export const $modals = types
  .model("Modals", {
    name: types.optional(types.maybeNull(types.string), null),
    params: types.frozen(null),
    
    // Модальные окна для скидок быстрых заказов
    createFastOrderDiscount: types.model({
      visible: types.optional(types.boolean, false),
      data: types.frozen(null),
    }).actions((self) => ({
      show() {
        self.visible = true;
      },
      hide() {
        self.visible = false;
      },
      setData(data) {
        self.data = data;
      },
    })),
    
    editFastOrderDiscount: types.model({
      visible: types.optional(types.boolean, false),
      data: types.frozen(null),
    }).actions((self) => ({
      show() {
        self.visible = true;
      },
      hide() {
        self.visible = false;
      },
      setData(data) {
        self.data = data;
      },
    })),
    
    deleteFastOrderDiscount: types.model({
      visible: types.optional(types.boolean, false),
      data: types.frozen(null),
    }).actions((self) => ({
      show() {
        self.visible = true;
      },
      hide() {
        self.visible = false;
      },
      setData(data) {
        self.data = data;
      },
    })),
  })
  .actions((self) => ({
    show(name, params) {
      self.name = name
      self.params = params
    },
    close() {
      self.name = null
      self.params = null
      
      // Закрываем все модальные окна скидок
      self.createFastOrderDiscount.hide();
      self.editFastOrderDiscount.hide();
      self.deleteFastOrderDiscount.hide();
    },
  }))
  .create({
    createFastOrderDiscount: {},
    editFastOrderDiscount: {},
    deleteFastOrderDiscount: {},
  });
